/** @file Shape of `Attachment.when` (R1, 21.8): host node, parent, and `draw` while (default) / unless. */
import { checkEnum } from '@zilo/pose3d-format/validate/fields/checkEnum';
import { checkHinted } from '@zilo/pose3d-format/validate/fields/checkHinted';
import { checkString } from '@zilo/pose3d-format/validate/fields/checkString';
import type { Shape } from '@zilo/pose3d-format/validate/fields/fieldCheck';
import { NAME_PATTERN } from '@zilo/pose3d-format/validate/fields/namePattern';

const name = checkString(NAME_PATTERN);

/** `{ hostNode, parent, draw? }`: drawn while (`'while'`, default) or unless (`'unless'`) hostNode hangs on parent. */
export const ATTACHMENT_WHEN_SHAPE: Shape = {
  required: { hostNode: name, parent: name },
  optional: {
    draw: checkHinted(checkEnum(['while', 'unless']),
      "draw 'while' (default) shows the attachment only while hostNode hangs from parent, 'unless' only while it does not (21.8)"),
  },
};
